<template>
  <router-view></router-view>
</template>

<script>
import { useVersionCheck } from "./composables/useVersionCheck";

export default {
  name: "App",

  setup() {
    useVersionCheck();
    return {};
  },
};
</script>
